<template>
  <div>
    <div class="flex">
      <div class="basic-tab" :class="{'tab-selected': selectedTab===0}" @click="selectedTab=0">주문번호별</div>
      <div class="basic-tab" :class="{'tab-selected': selectedTab===1}" @click="selectedTab=1">상품주문번호별</div>
    </div>
    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 nextPageName="nopage"
                 :table_width="800"
                 @ordering="ordering"
                 @selPageLength="selPageLength" v-if="selectedTab===0">
      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </div>

      <!-- 상세 -->
      <div slot="id" slot-scope="props">
        <div @click="clickDetail(props.item.id)" style="cursor:pointer;font-weight:bold">{{ props.item.id }}</div>
      </div>

      <!-- 총 상품 금액-->
      <div slot="all_price" slot-scope="props">
        {{ props.item.all_price | currency }}
      </div>

      <!-- 배송 금액 -->
      <div slot="delivery_price" slot-scope="props">
        {{ props.item.delivery_price | currency }}
      </div>

      <!-- 할인 금액 -->
      <div slot="discount_price" slot-scope="props">
        {{ props.item.discount_price | currency }}
      </div>

      <!-- 전체 금액-->
      <div slot="total_price" slot-scope="props">
        {{ props.item.total_price | currency }}
      </div>

      <!-- 주문 상품 -->
      <div slot="purchase_product" slot-scope="props">
        <div v-for="(pp,idx) in props.item.purchase_product" :key="'pp-'+idx">
          <span v-if="enableShow(pp.status)">{{ pp.name }}</span>
        </div>
      </div>

      <!-- 결제 방법 -->
      <div slot="pay_type" slot-scope="props">
        <span>{{ props.item.pay_type }}</span>
      </div>

      <!-- 일괄 처리 -->
      <div slot="spot">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e=> status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item,idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px" @click="clickChange">일괄처리</button>
        </div>
      </div>
    </admin-table>

    <!-- 탭 2 -->
    <admin-table :field_list="tableData"
                        :items="tableItems"
                        :filtered="filtered"
                        :allCount="allCount"
                        :filteredCount="filteredCount"
                        nextPageName="nopage"
                        :table_width="800"
                        @ordering="ordering"
                        @selPageLength="selPageLength" v-if="selectedTab===1">
      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </div>

      <!-- 상세 -->
      <div slot="id" slot-scope="props">
        <div @click="clickDetail(props.item.purchase)" style="cursor:pointer;font-weight:bold">{{ props.item.id }}</div>
      </div>

      <!-- 총 상품 금액-->
      <div slot="all_price" slot-scope="props">
        {{ props.item.all_price | currency }}
      </div>

      <!-- 배송 금액 -->
      <div slot="delivery_price" slot-scope="props">
        {{ props.item.delivery_price | currency }}
      </div>

      <!-- 할인 금액 -->
      <div slot="discount_price" slot-scope="props">
        {{ props.item.discount_price | currency }}
      </div>

      <!-- 전체 금액-->
      <div slot="total_price" slot-scope="props">
        {{ props.item.total_price | currency }}
      </div>

      <!-- 주문 상태 -->
      <div slot="status" slot-scope="props">
        {{ orderStatus(props.item.status) }}
      </div>

      <!-- 결제 상태 -->
      <div slot="pay_status" slot-scope="props">
        {{ payStatus(props.item.status )}}
      </div>

      <div slot="pay_type" slot-scope="props">
        <span>{{ props.item.pay_type }}</span>
      </div>

      <div slot="spot">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e=> status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item,idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px" @click="clickChange">일괄처리</button>
          <!--<button class="button" style="margin-left:8px" @click="cancelPurchase">취소처리</button>-->
        </div>
      </div>
    </admin-table>

    <modal name="cancelModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="삭제" :useTab="false" class="lp-modal-wrapper">
        <div>결제취소 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelModal')">취소</button>
          <button class="button is-primary" @click="confirmModal(900)">확인</button>
        </div>
      </admin-box-item>
    </modal>
  </div>
</template>

<script>
  import LpCheckBool from "../../../../module/common/LpCheckBool";
  import Const from "../../../../../utils/const"
  import ListMixin from "@/mixins/ListMixin"

  export default {
    name: 'DeliveryDoing',
    components: {LpCheckBool},
    mixins: [
      ListMixin
    ],
    data() {
      return {
      }
    },
    watch: {
      selectedTab(n){
        if(this.selectedTab===0){
          this.initializing('purchase', 'commerce/purchase?status=301', 'DeliveryDoing');
        }
        if(this.selectedTab===1){
          this.initializing('purchase_product', 'commerce/purchaseproduct?status=301', 'DeliveryDoing');
        }
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('purchase_product', 'commerce/purchaseproduct?status=301', 'DeliveryDoing');
      },
      getDataFromServer() {
        this.getData();
      },
      enableShow(status) {
        if(status===301) return true;
        else return false;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
